import React from 'react';
import { Flex, HStack } from '@chakra-ui/react';
import { SyncingInstallationAlert } from '#components';
import { useAccount } from '#contexts/account';
import {
  DateRangePicker, GroupBySelect, PerformanceTable, RepositorySelect,
} from './components';
import { useReviewerStatsQuery } from './hooks/useReviewerStatsQuery';
import { useFilters } from './contexts/filters';

export const Overview = () => {
  const {
    filters,
    setDateRange,
    setGroupBy,
    setRepositoryIds,
  } = useFilters();

  const { currentInstallation, refetch: refetchInstallations } = useAccount();

  const { reviewerStats, loading, refetch: refetchReviewerStats } = useReviewerStatsQuery({
    repositoryIds: filters.repositoryIds?.length ? filters.repositoryIds : undefined,
    startDate: filters.dateRange.startDate,
    endDate: filters.dateRange.endDate,
    groupBy: filters.groupBy,
  });

  return (
    <>
      <SyncingInstallationAlert
        margin="32px 0 0"
        variant="left-accent"
        installation={currentInstallation}
        refetchInstallation={refetchInstallations}
        onStatusActive={refetchReviewerStats}
      />

      <Flex
        direction={{ base: 'column', lg: 'row' }}
        justifyContent={{ lg: 'space-between' }}
        alignItems={{ base: 'flex-start', lg: 'center' }}
        width="full"
        gap={4}
        marginTop={8}
        marginBottom={4}
      >
        <GroupBySelect groupBy={filters.groupBy} onChange={setGroupBy} />
        <HStack spacing={4}>
          <RepositorySelect repositoryIds={filters.repositoryIds} onChange={setRepositoryIds} />
          <DateRangePicker dateRange={filters.dateRange} onChange={setDateRange} />
        </HStack>
      </Flex>

      <PerformanceTable data={reviewerStats} isLoading={loading} />
    </>
  );
};
